<script>
  export let title = '데이터가 없습니다';
  export let message = '';
  export let description = '';
  export let actionText = '';
  export let onAction = () => {};
  export let icon = '📭';

  if (message) {
    title = message;
  }
</script>

<div class="empty-state">
  <div class="empty-icon">{icon}</div>
  <h3 class="empty-title">{title}</h3>
  {#if description}
    <p class="empty-description">{description}</p>
  {/if}
  {#if actionText}
    <button class="btn btn-primary" on:click={onAction}>
      {actionText}
    </button>
  {/if}
</div>

<style>
  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    text-align: center;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    margin: 20px 0;
  }

  .empty-icon {
    font-size: 4rem;
    margin-bottom: 20px;
    opacity: 0.6;
  }

  .empty-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #333;
    margin: 0 0 12px 0;
  }

  .empty-description {
    font-size: 1rem;
    color: #666;
    margin: 0 0 24px 0;
    line-height: 1.5;
    max-width: 400px;
  }

  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    font-size: 0.95rem;
    font-weight: 500;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    text-decoration: none;
    transition: all 0.2s ease;
    min-height: 44px;
  }

  .btn-primary {
    background-color: #3273dc;
    color: white;
  }

  .btn-primary:hover {
    background-color: #2860b5;
    transform: translateY(-1px);
  }

  .btn-primary:active {
    transform: translateY(0);
  }
</style> 